import { useState } from "react"

import { Box, Button, TextField, Typography } from "@mui/material"

import PasswordInput from "../../Input"

import "./styles.css"

const MetricsLogin = ({ onClickFn, loading }) => {
    const [ username, setUsername ] = useState("")
    const [ password, setPassword ] = useState("")

    const handleLogin = () => {
        localStorage.setItem(
            "@kwikapi-admin-username",
            username
        )

        onClickFn(password)
    }

    return (
        <div className="metrics-login">
            <Box mb={2}>
                <Typography variant="h5">
                    Métricas Kwik
                </Typography>
            </Box>
            <TextField
                label="Username"
                name="username"
                defaultValue={username}
                onChange={(event) => setUsername(event.target.value)}
                fullWidth
                size="small"
                sx={{ marginBottom: ".5rem" }}
            />
            <PasswordInput
                label="Senha (admin)"
                name="password"
                defaultValue={password}
                onChange={(event) => setPassword(event.target.value)}
                onEnterPress={true}
                onKeyPress={(event) => {
                    if(event && event.key === "Enter")
                        handleLogin()
                }}
            />
            <Button
                variant="contained"
                color="primary"
                onClick={() => handleLogin()}
                disabled={! username || ! password}
                fullWidth
                sx={{ marginTop: ".5rem" }}
            >
                Login
            </Button>
        </div>
    )
}

export default MetricsLogin
